export const UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS';
export const SET_ERROR = 'SET_ERROR';
export const SET_SUCCESS = 'SET_SUCCESS';
export const RESET_APP_REDUCER = 'RESET_APP_REDUCER';
export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
